module.exports = __webpack_public_path__ + "img/elaterna_logo_web.3ff37913.svg";